import * as React from 'react';
import { useEffect, useState } from 'react';

import DateFormat from '@core/components/display/datetime/DateFormat';
import { classNames } from '@core/utils/functions/class-names';

import EventCard from '@/components/display/cards/EventCard';
import { Webinar, Event } from '@/types/ArticleType';
import fetchEvents from '@/utils/functions/wordpress/fetchEvents';
import fetchWebinars from '@/utils/functions/wordpress/fetchWebinars';

type EventsSectionProps = {
    className?: string;
};

const EventsSection = (props: EventsSectionProps) => {
    const { className } = props;
    const [events, setEvents] = useState<(Webinar | Event)[]>([]);

    useEffect(() => {
        fetchEvents(2, true).then(fetchedEvents => {
            fetchWebinars(2, true).then(fetchedWebinars => {
                setEvents(
                    [...fetchedEvents, ...fetchedWebinars]
                        .sort((a, b) => (a.eventStartDate < b.eventStartDate ? 1 : -1))
                        .slice(0, 4)
                );
            });
        });
    }, []);

    return (
        <>
            <div
                className={classNames(
                    'grid grid-cols-1 md:grid-cols-2 flex-grow-0 flex-shrink-0 w-full relative gap-10 p-10',
                    events.length === 4 ? 'xl:grid-cols-4' : 'xl:grid-cols-3',
                    className
                )}
            >
                {events.map(event => (
                    <EventCard
                        key={event.slug}
                        title={event.title}
                        type={event.type}
                        dateString={
                            event.type === 'webinar' ? (
                                <DateFormat dateStringOrTimestamp={(event as Webinar).customFields?.date! ?? 0} />
                            ) : (
                                (event as Event).customFields?.text_date || ''
                            )
                        }
                        startDate={new Date(event.eventStartDate * 1000)}
                        endDate={new Date(event.eventEndDate * 1000)}
                        description={event.excerpt}
                        location={(event as Event).customFields?.location || ''}
                        learnMoreLink={event.permalink}
                        registerLink={
                            (event as Event).customFields.registration_button_link?.url ||
                            (event as Event).customFields.header_button_1_link?.url ||
                            null
                        }
                    />
                ))}
            </div>
        </>
    );
};

export default EventsSection;
